import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fullscreen_from",
  "use": "fullscreen_from-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"fullscreen_from\"><path d=\"M9.387 10.667H5.44c-.853 0-1.493.64-1.493 1.493v1.173h8v-8h-1.173c-.747 0-1.387.64-1.387 1.493v3.84zm13.226 0v-3.84c0-.853-.64-1.493-1.493-1.493h-1.173v8h8v-1.173c0-.853-.64-1.493-1.493-1.493h-3.84zm0 10.666h3.84c.853 0 1.493-.64 1.493-1.493v-1.173h-8v8h1.173c.853 0 1.493-.64 1.493-1.493v-3.84zm-13.226 0v3.84c0 .853.64 1.493 1.493 1.493h1.173v-8h-8v1.173c0 .853.64 1.493 1.493 1.493h3.84z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol